var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00004 2.33329C10.7919 2.33329 12.25 3.79146 12.25 5.58329H14.4167C14.4167 2.59654 11.9868 0.166626 9.00004 0.166626C6.01329 0.166626 3.58337 2.59654 3.58337 5.58329V7.74996H2.50004C1.30512 7.74996 0.333374 8.72171 0.333374 9.91663V19.6666C0.333374 20.8615 1.30512 21.8333 2.50004 21.8333H15.5C16.695 21.8333 17.6667 20.8615 17.6667 19.6666V9.91663C17.6667 8.72171 16.695 7.74996 15.5 7.74996H5.75004V5.58329C5.75004 3.79146 7.20821 2.33329 9.00004 2.33329ZM15.5022 19.6666H10.0834V17.1988C10.728 16.8229 11.1667 16.1317 11.1667 15.3333C11.1667 14.1384 10.195 13.1666 9.00004 13.1666C7.80512 13.1666 6.83337 14.1384 6.83337 15.3333C6.83337 16.1306 7.27212 16.8229 7.91671 17.1988V19.6666H2.50004V9.91663H15.5L15.5022 19.6666Z",
    fill: "#0F2554"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.9fe66e632efb5d622ce3dd0bc27f8866.svg";
export { ForwardRef as ReactComponent };